var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurant24DpE8Eaed1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 8.25004H8.25V1.83337H6.41667V8.25004H4.58333V1.83337H2.75V8.25004C2.75 10.1934 4.27167 11.77 6.1875 11.8892V20.1667H8.47917V11.8892C10.395 11.77 11.9167 10.1934 11.9167 8.25004V1.83337H10.0833V8.25004ZM14.6667 5.50004V12.8334H16.9583V20.1667H19.25V1.83337C16.72 1.83337 14.6667 3.88671 14.6667 5.50004Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant24DpE8Eaed1);
export default __webpack_public_path__ + "static/media/restaurant_24dp_E8EAED 1.5c6fcf9f3e40f95675df1c636559926c.svg";
export { ForwardRef as ReactComponent };